import { InjectionToken } from '@angular/core';

import type { ISocialItem, ISupportItem, TSocialKey } from './social-link.type';

export const CAICHAT_SUPPORT_EMAIL = 'support@caichat.ai';
export const RPGC_SUPPORT_EMAIL = 'support@rpgc.ai';

export const CAICHAT_SOCIALS_CONFIG: Partial<Record<TSocialKey, ISocialItem>> = {
  telegram: {
    key: 'telegram',
    title: 'Telegram',
    link: 'https://www.telegram.me/caichatai',
    icon: 'ph ph-telegram-logo',
  },

  discord: {
    key: 'discord',
    title: 'Discord',
    link: 'https://www.discord.gg/YjBX4v4shh',
    icon: 'ph ph-discord-logo',
  },

  reddit: {
    key: 'reddit',
    title: 'Reddit',
    link: 'https://www.reddit.com/r/ChatbotsHub/',
    icon: 'ph ph-reddit-logo',
  },

  tiktok: {
    key: 'tiktok',
    title: 'TikTok',
    link: 'https://www.tiktok.com/@caichat',
    icon: 'ph ph-tiktok-logo',
  },

  youtube: {
    key: 'youtube',
    title: 'Youtube',
    link: 'https://www.youtube.com/channel/UCt4qBdVELr8juhzti46aLQw',
    icon: 'ph ph-youtube-logo',
  },

  twitter: {
    key: 'twitter',
    title: 'Twitter',
    link: 'https://www.x.com/Caichatai',
    icon: 'ph ph-x-logo',
  },

  email: {
    key: 'email',
    title: 'Email',
    link: 'mailto:support@caichat.ai',
    icon: 'ph ph-envelope',
  },
};

export const SUPPORT_LINKS_RPGC: ISupportItem[] = [
  {
    key: 'discord',
    link: 'https://discord.gg/TSgrxndvcp',
    icon: 'ph ph-discord-logo',
  },
  {
    key: 'email',
    link: 'mailto:support@rpgc.ai',
    icon: 'ph ph-envelope-simple',
  },
];

export const RPGC_SOCIALS_CONFIG: Partial<Record<TSocialKey, ISocialItem>> = {
  telegram: {
    key: 'telegram',
    title: 'Telegram',
    link: 'https://www.t.me/rpgcai',
    icon: 'ph ph-telegram-logo',
  },

  discord: {
    key: 'discord',
    title: 'Discord',
    link: 'https://discord.gg/TSgrxndvcp',
    icon: 'ph ph-discord-logo',
  },

  tiktok: {
    key: 'tiktok',
    title: 'TikTok',
    link: 'https://www.tiktok.com/@rpgcai',
    icon: 'ph ph-tiktok-logo',
  },

  twitter: {
    key: 'twitter',
    title: 'Twitter',
    link: 'https://www.x.com/rpgcai',
    icon: 'ph ph-x-logo',
  },

  email: {
    key: 'email',
    title: 'Email',
    link: `mailto:${RPGC_SUPPORT_EMAIL}`,
    icon: 'ph ph-envelope',
  },
};

export const SOCIAL_LINKS_TOKEN = new InjectionToken<Record<TSocialKey, ISocialItem>>('SOCIAL_LINKS_TOKEN');
export const SUPPORT_EMAIL_TOKEN = new InjectionToken<string>('SUPPORT_EMAIL_TOKEN');
